import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { Constants } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/heroAndText/helpers/HeroAndTextLayoutPortrait.textPart';
import { Flex } from '@react-three/flex';
import { observer } from 'mobx-react-lite';

import { HeroAndTextMoreCta } from './HeroAndTextMoreCta';
import { HeroAndTextParagraph } from './HeroAndTextParagraph';
import { HeroAndTextTitleLine } from './HeroAndTextTitleLine';

type Props = {
  gridCard: GridCard<PlaneTypes.Layout_HeroAndText_TextPart>;
};

export const HeroAndTexTextPartPortrait = observer(
  function HeroAndTexTextPartPortrait({ gridCard }: Props) {
    const { data } = gridCard;
    const { textPart } = data!.styles!;

    return (
      <Flex
        position={[0, gridCard.worldPosition.y, 0]}
        size={[textPart!.page.size.width, textPart!.page.size.height, 0]}
        alignItems='flex-start'
        justifyContent='center'
        centerAnchor
      >
        {textPart!.titleColumn && <HeroAndTextTitleLine gridCard={gridCard} />}
        {textPart!.paragraphs &&
          textPart?.paragraphs?.map((p, index) => (
            <HeroAndTextParagraph
              key={index + p.props.text}
              view={p}
              marginTop={Constants.FIGMA_PARAGRAPHS_LINE_HEIGHT}
            />
          ))}
        {Boolean(textPart!.cta) && <HeroAndTextMoreCta gridCard={gridCard} />}
      </Flex>
    );
  }
);
